<template>
  <div class="menuFrame">
    <loading :active.sync="isLoading"></loading>

    <div>
      <div id="track">
        <div class="d-flex justify-content-between">
          <div>
            <a href="/ExhibitorServiceTW/en/">Exhibition List</a><span>/</span>
            <em name="Exhibition"></em><span>/</span>Other Events<span>/</span
            ><span class="px-0">{{ EventDetail.eEventName }} </span>
          </div>
          <div>
            <span class="bold">Account :</span>
            <span> {{ UserId }}</span>
          </div>
        </div>
      </div>
      <!-- track end -->
      <!-- article -->
      <article>
        <div class="MbDevice">
          <div class="homeLeft">
            <div class="UserAccount ml-1">
              <span class="bold">Account :</span>
              <span> {{ UserId }}</span>
            </div>
            <hr />
            <div class="expoLogo"><img :src="ExhLogo" width="100%" /></div>
            <div class="expoInfo">
              <p class="bold" name="Exhibition"></p>
              <p>{{ ExhBegin }} - {{ ExhEnd }}</p>
              <p>{{ ExhVenue }}</p>
            </div>
            <p class="clear"></p>
          </div>
        </div>

        <div class="contentBox">
          <h1>{{ EventDetail.eEventName }}</h1>

          <p class="formTitle mt-5">Event Description</p>
          <p class="mb-4 mt-1 event-desc" v-html="EventDetail.ebackEndDesc"></p>

          <p class="formTitle mt-3">Available Time</p>
          <p class="mb-4 mt-1">{{ OpendateString }} - {{ ClosedateString }}</p>

          <p class="formTitle mt-3" v-if="EventDetail.ebackEndNotice">Notes</p>
          <p
            class="mb-4 mt-1"
            v-if="EventDetail.ebackEndNotice"
            v-html="EventDetail.ebackEndNotice"
          ></p>

          <div class="mt-5" v-if="ShowRegiter">
            <div class="d-flex align-items-center justify-content-start mb-4">
              <div v-if="isStart">
                <div v-if="booth_sqm >= minBoothQty">
                  <div v-if="maxProductQty <= RegisterListNum">
                    <div
                      class="btn btn-lg btn-primary text-nowrap disabled"
                      v-if="LocalExh"
                    >
                      Registration Limit Reached
                    </div>
                    <div
                      class="btn btn-lg btn-primary text-nowrap disabled"
                      v-if="!LocalExh"
                    >
                      Published limit reached
                    </div>
                  </div>
                  <div v-else>
                    <div
                      class="btn btn-lg btn-primary text-nowrap"
                      @click.prevent="toProductSelect"
                      v-if="LocalExh"
                    >
                      Register
                    </div>

                    <div
                      class="btn btn-lg btn-primary text-nowrap"
                      @click.prevent="toProductSelect"
                      v-if="!LocalExh"
                    >
                      Make a Publish
                    </div>
                  </div>
                </div>
                <div v-else>
                  <div class="btn btn-lg btn-primary text-nowrap disabled">
                    Not Eligible for Registration
                  </div>
                </div>
              </div>
              <div v-else-if="!isStart">
                <div class="btn btn-lg btn-primary text-nowrap disabled">
                  Not Yet Open
                </div>
              </div>
            </div>

            <div class="alert">
              <p>
                1. You must have at least
                <span class="red"> {{ minBoothQty }} </span>booth to participate
                in this event.
              </p>
              <!-- <p>
                2. 您已經報名
                <span class="red">{{ RegisterListNum }}</span>
                個產品，還可以選擇
                <span class="red">{{ maxProductQty - RegisterListNum }}</span>
                個產品參加本活動
              </p> -->
              <p>
                2. You have Registered
                <span class="red">{{ RegisterListNum }}</span> product(s), you
                can still add
                <span class="red">{{ maxProductQty - RegisterListNum }}</span>
                product(s)
              </p>
            </div>

            <div
              v-if="RegisterListNum > 0"
              class="mt-4"
              style="font-size: 22px"
            >
              <div v-if="LocalExh">
                <i class="fas fa-chevron-circle-down text-warning"></i>
                Registered Products
              </div>

              <div v-else>
                <i class="fas fa-chevron-circle-down text-warning"></i>
                Published Product
              </div>
            </div>

            <div class="row" v-if="booth_sqm >= minBoothQty">
              <div
                class="col-sm-3 mb-2"
                v-for="(item, index) in MarketingRegisterList"
                :key="index"
              >
                <div class="card mt-4">
                  <div class="card-body">
                    <div class="imgstyle text-center">
                      <img
                        :src="`//www.chanchao.com.tw/exhibitorServicefiles/products/${item.proImg}`"
                        class="img-fluid mt-2"
                        width="130px"
                      />
                    </div>
                    <ul class="list-group list-group-flush mx-2">
                      <div class="mt-3 mb-2 h5">
                        <strong>{{ item.proName }}</strong>
                      </div>
                      <p class="gray">Category：{{ item.emCatName }}</p>
                      <p class="gray" v-if="inputOnlineDateHidden == 0">
                        Launch Date：{{ item.reg_LaunchDate }}
                      </p>
                      <p class="gray" v-if="inputPriceHidden == 0">
                        Regular Price：{{ item.reg_Price }}
                      </p>
                      <p class="gray" v-if="inputDiscountPriceHidden == 0">
                        Exhibition Offer：{{ item.reg_DiscountPrice }}
                      </p>
                      <div class="gray" v-if="inputDescHidden == 0">
                        <div v-if="inputDescName">
                          {{ inputDescName }}：{{ item.ereg_Desc }}
                        </div>
                      </div>
                      <div class="gray" v-if="inputDescHidden2 == 0">
                        <div v-if="inputDescName2">
                          {{ inputDescName2 }}：{{ item.ereg_Desc2 }}
                        </div>
                      </div>

                      <div class="card-footer mt-3 bg-white">
                        <div
                          class="d-flex justify-content-center align-items-center mt-2"
                        >
                          <div
                            class="btn btn-primary py-2"
                            @click.prevent="EditPromotion(item.regId)"
                          >
                            Edit
                          </div>
                          <div
                            class="btn btn-secondary ml-3 py-2"
                            @click.prevent="DelPromotion(item.regId)"
                          >
                            Cancel
                          </div>
                        </div>
                      </div>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </article>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import axios from "axios";

export default {
  metaInfo() {
    return {
      title: "Other Events - Chan Chao Exhibitor Online Service System",
    };
  },

  data() {
    return {
      LocalExh: true,
      UserId: "",
      RegNo: "",
      CSRF_Token: "",
      lang: "tw",
      EventDetail: {},
      MarketingRegisterList: [],
      eventId: "",
      booth_sqm: "",
      minBoothQty: "",
      maxProductQty: "",
      RegisterListNum: "",

      inputDescHidden: "",
      inputDescHidden2: "",
      inputDescName2: "",

      inputOnlineDateHidden: "",
      inputPriceHidden: "",
      inputDiscountPriceHidden: "",
      ShowRegiter: false,

      OpendateString: "",
      ClosedateString: "",
      OpenSec: "",
      OpenMin: "",
      CloseSec: "",
      CloseMin: "",
      inputDescName: "",

      ExhLogo: "",
      ExhBegin: "",
      ExhEnd: "",
      ExhVenue: "",
      eExhVenue: "",
      isStart: true,
    };
  },

  watch: {},

  methods: {
    toProductSelect() {
      const vm = this;

      if (vm.booth_sqm >= vm.minBoothQty) {
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/promotionSelectPro?no=${vm.RegNo}&eventId=${vm.eventId}`;
      } else {
        alert(
          "Your registered booth count must exceed the minimum required to sign up for this activity.",
        );
      }
    },

    EditPromotion(id) {
      const vm = this;
      document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/promotionEdit?no=${vm.RegNo}&eventId=${vm.eventId}&regId=${id}`;
    },

    DelPromotion(id) {
      const vm = this;

      if (
        confirm(
          "Please confirm you want to cancel the promotion of this product.",
        )
      ) {
        const info = {
          CSRF: vm.CSRF_Token,
        };

        const url = `/apiExhibitors/MarketingEventRegister/${vm.RegNo}/${id}`;

        axios.post(url, { CSRF: vm.CSRF_Token }).then(function (response) {
          // console.log(response.data)

          if (response.data.Code == 200) {
            document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/promotion?eventId=${vm.eventId}&no=${vm.RegNo}`;
          } else if (response.data.Code == 253) {
            alert("Registration number is incorrect or does not exist.");
            document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/promotion?eventId=${vm.eventId}&no=${vm.RegNo}`;
          } else if (response.data.Code == 252) {
            alert("CSRF validation failed.");
            document.location.href = `https://www.chanchao.com.tw/`;
          } else if (response.data.Code == 500) {
            alert("The system is busy. Please try again later.");
            document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/promotion?eventId=${vm.eventId}&no=${vm.RegNo}`;
          }
        });
      } else {
        return false;
      }
    },
  },

  computed: {},

  created() {
    const vm = this;

    //CSRF_Token
    axios
      .get("https://www.chanchao.com.tw/apiExhibitors/CSRF_Token")
      .then((response) => {
        vm.CSRF_Token = response.data;
      });

    axios
      .get(`https://www.chanchao.com.tw/apiExhibitors/UserID`)
      .then((response) => {
        vm.UserId = response.data;
      });

    //url取出展碼
    let currentUrl = location.href;
    vm.eventId = currentUrl.split("eventId=")[1].split("&")[0];
    vm.RegNo = currentUrl.split("no=")[1];

    // console.log(vm.RegNo)

    axios
      .get(
        `https://www.chanchao.com.tw/apiExhibitors/Exhibition/${vm.RegNo}?lang=${vm.lang}`,
      )
      .then((response) => {
        vm.ExhLogo = `//www.ccie.com.tw/exhibition/images/exlogo/${response.data.ExhLogo}`;
        vm.ExhBegin = response.data.ExhBegin;
        vm.ExhEnd = response.data.ExhEnd;
        vm.ExhVenue = response.data.ExhVenue;
        vm.eExhVenue = response.data.eExhVenue;
        let ExpoLocation = response.data.Data.ExpoLocation;

        if (ExpoLocation === "T" || ExpoLocation === null) {
          vm.LocalExh = true;
        } else {
          vm.LocalExh = false;
        }
      });

    //取得總資料
    axios
      .get(
        `https://www.chanchao.com.tw/apiExhibitors/MarketingEvent?eventId=${vm.eventId}`,
      )
      .then((response) => {
        if (response.data.Code == 200) {
          vm.EventDetail = response.data.Data;
          vm.minBoothQty = response.data.Data.minBoothQty;
          vm.maxProductQty = response.data.Data.maxProductQty;

          vm.inputDescHidden = response.data.Data.inputDescHidden;
          vm.inputDescHidden2 = response.data.Data.inputDescHidden2;

          vm.inputOnlineDateHidden = response.data.Data.inputOnlineDateHidden;
          vm.inputPriceHidden = response.data.Data.inputPriceHidden;
          vm.inputDiscountPriceHidden =
            response.data.Data.inputDiscountPriceHidden;

          vm.inputDescName = response.data.Data.einputDescName;

          vm.inputDescName2 = response.data.Data.einputDescName2;

          // vm.backEndStartDate = response.data.Data.backEndStartDate

          let OpenRegiterDate = response.data.Data.backEndStartDate;
          let CloseRegiterDate = response.data.Data.backEndEndDate;
          let Nowdate = Date.parse(new Date()).valueOf();

          //時間標記Timestamp轉日期(backEndStart)

          let Opentimestamp = Number(OpenRegiterDate);
          let Opendate = new Date(Opentimestamp);

          if (Opendate.getMinutes() == 0) {
            vm.OpenMin = "00";
          } else {
            vm.OpenMin = Opendate.getMinutes();
          }

          if (Opendate.getSeconds() == 0) {
            vm.OpenSec = "00";
          } else {
            vm.OpenSec = Opendate.getSeconds();
          }

          vm.OpendateString =
            Opendate.getFullYear() +
            "/" +
            (Opendate.getMonth() + 1) +
            "/" +
            Opendate.getDate() +
            " " +
            Opendate.getHours() +
            ":" +
            vm.OpenMin +
            ":" +
            vm.OpenSec;

          //時間標記Timestamp轉日期(backEndEndDate)

          let Closetimestamp = Number(CloseRegiterDate);
          let Closedate = new Date(Closetimestamp);

          if (Closedate.getMinutes() == 0) {
            vm.CloseMin = "00";
          } else {
            vm.CloseMin = Closedate.getMinutes();
          }

          if (Closedate.getSeconds() == 0) {
            vm.CloseSec = "00";
          } else {
            vm.CloseSec = Closedate.getSeconds();
          }

          vm.ClosedateString =
            Closedate.getFullYear() +
            "/" +
            (Closedate.getMonth() + 1) +
            "/" +
            Closedate.getDate() +
            " " +
            Closedate.getHours() +
            ":" +
            vm.CloseMin +
            ":" +
            vm.CloseSec;

          let archived = response.data.Data.archived;
          if (archived == 1) {
            vm.ShowRegiter = false;
          } else {
            vm.ShowRegiter = true;

            if (Nowdate < OpenRegiterDate) {
              vm.ShowRegiter = true;
              vm.isStart = false;
            } else if (
              Nowdate >= OpenRegiterDate &&
              Nowdate <= CloseRegiterDate
            ) {
              vm.ShowRegiter = true;
              vm.isStart = true;
            } else if (Nowdate > CloseRegiterDate) {
              vm.ShowRegiter = false;
              vm.isStart = true;
            }
          }

          axios
            .get(
              `https://www.chanchao.com.tw/apiExhibitors/MarketingEventRegister?regNo=${vm.RegNo}&eventId=${vm.eventId}`,
            )
            .then((response) => {
              vm.MarketingRegisterList = response.data.Data;

              if (response.data.datatotal) {
                vm.RegisterListNum = response.data.datatotal;
              } else {
                vm.RegisterListNum = 0;
              }
            });
        } else {
          let lastPage = document.referrer;

          if (lastPage) {
            document.location.href = `${lastPage}`;
          } else {
            document.location.href =
              "https://www.chanchao.com.tw/ExhibitorServiceTW/en/";
          }
        }
      });

    //實體攤位數
    axios
      .get(`https://www.chanchao.com.tw/apiExhibitors/Exhibitor/${vm.RegNo}`)
      .then((response) => {
        // console.log(response.data)
        vm.booth_sqm = response.data.Data.booth_sqm;
      });
  },
};
</script>

<style lang="scss">
.event-desc ol {
  margin-left: 20px; /* 控制外邊距 */
}
</style>
